import { render } from "./AddCharge.vue?vue&type=template&id=748ec4ed"
import script from "./AddCharge.vue?vue&type=script&lang=js"
export * from "./AddCharge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__